import React, {useEffect, useRef} from 'react';

export const ProviderPreview = ({provider, onClickOutSide, onClick}) => {
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutSide()
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  if(!provider) {
    return;
  }

  const providerImage = (provider?.photos || [])[0] || 'https://ik.imagekit.io/uncwgd4ot/jamful/placeholder-image.png';

  return (
      <div className="flex p-4" ref={ref} onClick={onClick}>
        <div className="mr-4">
          <img src={providerImage} alt={provider.name}
                    width={80} height={80} style={{minWidth:80, minHeight: 80, borderRadius: 4, border:'1px solid #ccc' }}/>
        </div>
        <div>
          <div className="flex items-center mb-1">
            <p className="font-bold mr-1">{provider.name}</p>
          </div>
          <p className="text-sm text-neutral-500 mb-1">{provider.locationHint}</p>
          <div
            className="text-sm">{(provider.types || []).map(a => (a || '').replace(/[a-zA-Z]+/g, '').trim()).join(', ')}</div>
        </div>
      </div>
  );
};
